<template>
  <div class="signature-content-dialog">
    <VOverlay v-if="isLoading">
      <VProgressCircular indeterminate />
    </VOverlay>
    <div class="dialog-header">
      <h2 style="flex-grow: 1">{{ title }}</h2>
      <VBtn style="padding: 0; min-width: 30px" v-if="canClose" depressed @click="handleClickClose">
        <VIcon color="#3f505f">mdi-close-circle-outline</VIcon>
      </VBtn>
    </div>
    <div class="content">
      <slot />
    </div>
    <div v-if="hasFooterSlot" class="dialog-footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'SignatureDialogLayout',
  props: {
    dialog: Object,
    title: {
      type: String,
      required: true
    },
    actionButtons: {
      type: Array,
      required: false,
      default: null
    },
    canClose: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('Payment', ['isLoading']),
    hasFooterSlot() {
      return !!this.$slots.footer;
    }
  },
  methods: {
    handleClickClose() {
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss">
.signature-content-dialog {
  background-color: #f0f1f2 !important;
  display: flex;
  flex-direction: column;
  border-radius: 0;
  margin: 0;
  height: 100%;
  position: fixed;
  overflow-y: auto;
  top: 0;
  left: 0;

  .dialog-header {
    padding: 20px 20px;
    background-color: #f6f6f8;
    border-bottom: 1px solid #d9d8de;
    display: flex;
    align-items: center;

    h2 {
      color: #3f505f !important;
      font-size: 22px;
      font-weight: 600;
    }

    .close {
      float: right;
      padding: 2px 0px;
    }
  }

  .dialog-footer {
    padding: 16px 16px 40px 16px;
    display: flex;
    background-color: #f6f6f8;
    border-top: 1px solid #d9d8de;
    gap: 12px;

    button {
      flex-grow: 1;
      border-radius: 8px;
      padding: 8px 24px !important;
    }
  }

  .content {
    padding: 16px;
    flex-grow: 1;
    overflow-y: auto;
    overflow-x: hidden;

    .section-header {
      color: #626263;
      font-size: 13px;
      letter-spacing: 0.26px;
      text-transform: uppercase;
    }
  }

  .divider {
    border: 0.5px solid #e2e8f0;
    margin: 14px 0;
  }
}

.signature-information {
  font-size: 12px;
  margin: 24px 0;
}
</style>
